export * from './src/i18n.module';
export * from './src/translate.pipe';
